import React from 'react';

const TailwindTest = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            🎨 Tailwind CSS Test Page
          </h1>
          <p className="text-xl text-gray-600">
            Testing Tailwind CSS installation and utilities
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* Card 1 */}
          <div className="bg-white rounded-lg shadow-lg p-6 transform hover:scale-105 transition duration-300 text-center">
            <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-4 mx-auto">
              <span className="text-white text-2xl">🚀</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Colors</h3>
            <p className="text-gray-600 mb-4">
              Testing Tailwind's color palette and gradients
            </p>
            <div className="flex gap-2 justify-center">
              <div className="w-8 h-8 bg-red-500 rounded"></div>
              <div className="w-8 h-8 bg-green-500 rounded"></div>
              <div className="w-8 h-8 bg-blue-500 rounded"></div>
              <div className="w-8 h-8 bg-yellow-500 rounded"></div>
              <div className="w-8 h-8 bg-purple-500 rounded"></div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-lg shadow-lg p-6 transform hover:scale-105 transition duration-300 text-center">
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-4 mx-auto">
              <span className="text-white text-2xl">📱</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Responsive</h3>
            <p className="text-gray-600 mb-4">
              This layout adapts to different screen sizes
            </p>
            <div className="bg-gray-100 p-3 rounded">
              <p className="text-sm text-gray-700">
                Resize your browser to see the magic! ✨
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-lg shadow-lg p-6 transform hover:scale-105 transition duration-300 text-center">
            <div className="w-12 h-12 bg-purple-500 rounded-full flex items-center justify-center mb-4 mx-auto">
              <span className="text-white text-2xl">⚡</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-800 mb-2">Utilities</h3>
            <p className="text-gray-600 mb-4">
              Testing various Tailwind utility classes
            </p>
            <button className="bg-purple-500 hover:bg-purple-600 text-white font-semibold py-2 px-4 rounded-lg transition duration-200">
              Hover Me!
            </button>
          </div>
        </div>

        {/* Typography Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Typography</h2>
          <div className="space-y-4">
            <h1 className="text-4xl font-bold text-gray-900">Heading 1 - Bold</h1>
            <h2 className="text-3xl font-semibold text-gray-800">Heading 2 - Semibold</h2>
            <h3 className="text-2xl font-medium text-gray-700">Heading 3 - Medium</h3>
            <p className="text-lg text-gray-600">
              This is a paragraph with larger text. Tailwind makes it easy to style text with utility classes.
            </p>
            <p className="text-base text-gray-600">
              Regular paragraph text. You can use various text sizes, weights, and colors.
            </p>
            <p className="text-sm text-gray-500 italic">
              Small italic text for captions or secondary information.
            </p>
          </div>
        </div>

        {/* Buttons Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Buttons</h2>
          <div className="flex flex-wrap gap-4 justify-center">
            <button className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
              Primary Button
            </button>
            <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
              Success Button
            </button>
            <button className="bg-red-500 hover:bg-red-600 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
              Danger Button
            </button>
            <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md hover:shadow-lg">
              Secondary Button
            </button>
            <button className="border-2 border-purple-500 text-purple-500 hover:bg-purple-500 hover:text-white font-semibold py-3 px-6 rounded-lg transition duration-200">
              Outline Button
            </button>
          </div>
        </div>

        {/* Badges Section */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-12 text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">Badges & Tags</h2>
          <div className="flex flex-wrap gap-3 justify-center">
            <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full text-sm font-semibold">
              Tailwind CSS
            </span>
            <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-semibold">
              React
            </span>
            <span className="bg-purple-100 text-purple-800 px-4 py-2 rounded-full text-sm font-semibold">
              JavaScript
            </span>
            <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-full text-sm font-semibold">
              Frontend
            </span>
            <span className="bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-semibold">
              UI/UX
            </span>
          </div>
        </div>

        {/* Alert Box */}
        <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-lg mb-12 text-center">
          <div className="flex items-center justify-center">
            <div className="flex-shrink-0">
              <span className="text-2xl">✅</span>
            </div>
            <div className="ml-4">
              <h3 className="text-lg font-semibold text-green-800">
                Tailwind CSS is Working!
              </h3>
              <p className="text-green-700 mt-1">
                If you can see this styled page, Tailwind CSS has been successfully installed and configured.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-gray-600">
          <p className="text-lg">
            🎉 Tailwind CSS Test Page - Everything looks great!
          </p>
          <p className="text-sm mt-2">
            You can now use Tailwind utility classes throughout your project.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TailwindTest;

